
























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { CtxMenuItem } from '../../logic/MenuItems'

@Component({})
export default class ContextMenuItem extends Vue {
  @Prop() item!: CtxMenuItem

  @Prop({ type: Boolean, default: false, required: false }) showArrow!: boolean

}
